import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, ChevronRight } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { useSiteImage } from "@/contexts/SiteImagesContext";

export default function PlaceCard({ place, variant = "default" }) {
  const { tx, t } = useI18n();
  const placeFallback = useSiteImage("place_default", "");
  const cat = place.category;
  const isRedCat = cat?.color === "red";
  const img = place.image_url || placeFallback;
  return (
    <Link
      to={`/places/${place.slug}`}
      data-testid={`place-card-${place.slug}`}
      className="group relative block bg-card rounded-2xl overflow-hidden border border-border hover:-translate-y-1 hover:shadow-xl transition-all"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        {img ? (
          <img
            src={img}
            alt={tx(place.title)}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <MapPin className="w-10 h-10 text-muted-foreground" />
          </div>
        )}
        {place.featured && (
          <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-[hsl(var(--primary-red))] text-white text-xs font-semibold tracking-wide flex items-center gap-1 animate-bounce-in">
            <Star className="w-3 h-3 fill-white" /> Featured
          </span>
        )}
        {cat && (
          <span className={`absolute top-3 right-3 px-2.5 py-1 rounded-full text-xs font-semibold text-white ${
            isRedCat ? "bg-[hsl(var(--primary-red))]" : "bg-[hsl(var(--primary-green))]"
          }`}>
            {tx(cat.name)}
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-display text-lg font-semibold leading-tight tracking-tight group-hover:text-[hsl(var(--primary-red))] transition-colors line-clamp-2">
          {tx(place.title)}
        </h3>
        {tx(place.short_description) && (
          <p className="mt-2 text-sm text-muted-foreground line-clamp-2">
            {tx(place.short_description)}
          </p>
        )}
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-muted-foreground flex items-center gap-1 truncate">
            <MapPin className="w-3.5 h-3.5 flex-shrink-0" />
            <span className="truncate">{place.address || "—"}</span>
          </span>
          <span className="flex items-center gap-1 text-xs font-semibold text-[hsl(var(--primary-green))] group-hover:gap-2 transition-all">
            {t.common.viewDetails}
            <ChevronRight className="w-3.5 h-3.5" />
          </span>
        </div>
      </div>
    </Link>
  );
}
